import { apiFetch } from "../lib/api";

export interface IndicatorSpecOut {
  type:
    | "sma"
    | "ema"
    | "wma"
    | "bollinger"
    | "donchian"
    | "rsi"
    | "macd"
    | "stochastic"
    | "atr"
    | "roc";
  params: Record<string, number | string>;
  pane: "price" | "below";
  color?: string | null;
  label?: string | null;
}

export interface StrategyCatalogEntry {
  key: string;
  display_name: string;
  description: string;
  supported_instruments: string[];
  supported_modes: string[];
  default_indicators: IndicatorSpecOut[];
}

export interface StrategyDetail extends StrategyCatalogEntry {
  params_schema: Record<string, unknown>;
  default_params: Record<string, unknown>;
}

export async function listStrategies(): Promise<StrategyCatalogEntry[]> {
  return apiFetch<StrategyCatalogEntry[]>("/strategies");
}

export async function getStrategy(key: string): Promise<StrategyDetail> {
  return apiFetch<StrategyDetail>(`/strategies/${encodeURIComponent(key)}`);
}
